<template>
  <drop-down v-if="langs.length > 1" position="right" direction="none">
    <p-button slot="title"
              slot-scope="{isOpen}"
              type="default"
              size="md"
              round
              :aria-expanded="isOpen"
              class="dropdown-toggle m-0">
      {{ locale.label }}
    </p-button>
    <a v-for="(lang, i) in langs" :key="`lang${i}`" class="dropdown-item" @click="setLang(lang)">{{ lang.label }}</a>
  </drop-down>
</template>

<script>
  import DropDown from './Dropdown'
  import moment from 'moment'
  import axios from 'axios'

  export default {
    name: 'LocaleDropDown',
    components: { DropDown },
    created () {},
    methods: {
      setLang: function (lang) {
        this.$i18n.locale = lang.value
        moment.locale(lang.value)
        localStorage.setItem('locale', lang.value)
        axios.defaults.headers.common['Accept-Language'] = lang.value
        document.querySelector('html').setAttribute('lang', lang.value)
      }
    },
    computed: {
      langs: function () {
        const enabledLanguages = this.$auth.user.customer.settings.contract.enabledLanguages
        return enabledLanguages.map(lng => ({value: lng, label: lng.toUpperCase()}))
      },
      locale: function () {
        return this.langs.find(lang => lang.value === this.$i18n.locale) || this.langs[0]
      }
    }
  }
</script>
